(() => {
  const motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  const apply = () => {
    const behavior = motionOk.matches ? 'smooth' : 'auto';
    document.documentElement.style.setProperty('scroll-behavior', behavior);
    document.querySelector('.page-wrapper')?.style.setProperty('scroll-behavior', behavior);
  };

  apply();
  motionOk.addEventListener?.('change', apply);

  const shrinkVideoselz = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const roots = document.querySelectorAll(
      '#shopify-section-178856202038eb088f, [id*="videoselz_video_carousel"], #videoselz-carousel-app, [data-vdslz-source]'
    );

    roots.forEach((root) => {
      root.style.setProperty('zoom', '0.75', 'important');
    });
  };

  shrinkVideoselz();
  document.addEventListener('DOMContentLoaded', shrinkVideoselz);
  window.addEventListener('load', shrinkVideoselz);
  [500, 1500, 3000].forEach((ms) => setTimeout(shrinkVideoselz, ms));
})();
